export default "__VITE_ASSET__2hOIOaLj__"